// Starch powder on a sticky mochi. powder is 0..1 per vertex of the rest mesh.
// Dusting lands on the upper, front-facing skin; rubbing wipes it off; the bare
// skin is sticky. The renderer reads powder to whiten and roughen the surface.
function random(seed){let s=seed>>>0||1;return()=>{s=(s+0x6D2B79F5)>>>0;let t=s;t=Math.imul(t^(t>>>15),t|1);t^=t+Math.imul(t^(t>>>7),t|61);return((t^(t>>>14))>>>0)/4294967296;};}
export class PowderCoat{
  constructor({rest,center,radius,seed=1}){
    this.rest=rest;this.center=center;this.radius=radius;this.random=random(seed);
    this.powder=new Float32Array(rest.length/3);this.changed=false;
  }
  near(point,radius,fn){
    const p=this.rest,r2=radius*radius;
    for(let i=0;i<this.powder.length;i++){
      const dx=p[i*3]-point[0],dy=p[i*3+1]-point[1],dz=p[i*3+2]-point[2],d2=dx*dx+dy*dy+dz*dz;
      if(d2<r2)fn(i,Math.exp(-d2/(r2*.35)));
    }
  }
  // The starting look: the left half dusted, the right half bare and glossy,
  // split by a soft, wavy edge, so the two feels can be compared at once.
  prime(){
    const p=this.rest,c=this.center,R=this.radius;
    for(let i=0;i<this.powder.length;i++){
      const x=p[i*3],y=p[i*3+1],z=p[i*3+2];
      const edge=.07*Math.sin(y/R*9)+.05*Math.sin(z/R*11+1.3);
      const side=((c[0]-x)/R+edge)/.14,t=Math.max(0,Math.min(1,.5+side));
      const under=Math.max(0,Math.min(1,((y-c[1])/R+.55)/.4));
      this.powder[i]=t*t*(3-2*t)*under;
    }
    this.primed=this.powder.slice();this.changed=true;
  }
  restore(){if(this.primed)this.powder.set(this.primed);else this.powder.fill(0);this.changed=true;}
  // The skin vertex that lies furthest along a direction from the center.
  surfaceToward(dir){
    const p=this.rest,c=this.center;let best=0,bestDot=-Infinity;
    for(let i=0;i<this.powder.length;i++){
      const x=p[i*3]-c[0],y=p[i*3+1]-c[1],z=p[i*3+2]-c[2],d=(x*dir[0]+y*dir[1]+z*dir[2])/(Math.hypot(x,y,z)||1);
      if(d>bestDot){bestDot=d;best=i;}
    }
    return [p[best*3],p[best*3+1],p[best*3+2]];
  }
  // One pat of the powder puff: a few soft patches on the top and front.
  dust(){
    const c=this.center,R=this.radius;
    for(let k=0;k<4;k++){
      // The first patch always lands on top, where a puff pats first.
      const a=this.random()*Math.PI*2,up=k===0?.95:.35+.6*this.random();
      const dir=[Math.cos(a)*Math.sqrt(1-up*up),up,Math.abs(Math.sin(a))*Math.sqrt(1-up*up)];
      this.near(this.surfaceToward(dir),R*.8,(i,w)=>{this.powder[i]=Math.min(1,this.powder[i]+.7*w);});
    }
    this.changed=true;
  }
  rub(point,dt){
    this.near(point,this.radius*.35,(i,w)=>{const next=Math.max(0,this.powder[i]-dt*1.6*w);if(next!==this.powder[i]){this.powder[i]=next;this.changed=true;}});
  }
  // 1 on bare skin, near 0 under a full coat of powder.
  stickiness(point){
    let sum=0,weight=0;this.near(point,this.radius*.3,(i,w)=>{sum+=this.powder[i]*w;weight+=w;});
    return weight?1-sum/weight:1;
  }
}
